import { TASK_SERVICE } from "../../../constants";
import { apiOptions, apiRequest } from "../../../utils";

const API_HOLD_REASONS = `${TASK_SERVICE}/hold-reasons`;
const API_RESCHEDULE_REASONS = `${TASK_SERVICE}/rescheduled-reasons`;

export const orderReasons = {
  getHoldReasons: async ({ filters, sort, params, signal } = {}) => {
    const options = await apiOptions({
      url: API_HOLD_REASONS,
      method: "get",
      signal,
      params,
      filters,
      sort,
    });
    return apiRequest(options);
  },
  getRescheduleReasons: async ({ filters, sort, params, signal } = {}) => {
    const options = await apiOptions({
      url: API_RESCHEDULE_REASONS,
      method: "get",
      signal,
      params,
      filters,
      sort,
    });
    return apiRequest(options);
  },
  updateHoldReasons: async ({ data, modifiedOn, toastMessageConfig = {} }) => {
    const options = await apiOptions({
      url: API_HOLD_REASONS,
      method: "put",
      data,
      modifiedOn,
    });
    return apiRequest(options, toastMessageConfig);
  },
  updateRescheduleReasons: async ({
    data,
    modifiedOn,
    toastMessageConfig = {},
  }) => {
    const options = await apiOptions({
      url: API_RESCHEDULE_REASONS,
      method: "put",
      data,
      modifiedOn,
    });
    return apiRequest(options, toastMessageConfig);
  },
};
